import { Link } from "react-router-dom";

function Footer() {
    return (
        <>
            <footer style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                backgroundColor: "#f8f9fa",
                padding: "10px 0",
                textAlign: "center",
                zIndex: 1000
            }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6">
                            © Owned by <Link to="/dashboard">lea.trining</Link>
                        </div>
                        <div className="col-md-6">
                            <div className="text-md-end footer-links d-none d-sm-block">
                                {/* <a href="javascript:void(0);">About Us</a>
                                <a href="javascript:void(0);">Help</a>
                                <a href="javascript:void(0);">Contact Us</a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
